import { GetClubsByZoneResponse } from '@aaa-ncnu-ie/mypolicy-api-registrations';
import { AxiosError } from 'axios';
import { useEffect } from 'react';

import { getCookie, setCookieWithExpiration } from '../utils/helpers';

const useAuthCheck = (error: AxiosError | null) => {
  const mprZipCookie = getCookie('mpr_zip');
  const zipCodeCookie: GetClubsByZoneResponse | null = mprZipCookie
    ? JSON.parse(mprZipCookie)
    : null;

  const shouldRedirect =
    error?.response?.status === 403 || error?.response?.status === 401;

  useEffect(() => {
    const shouldStoreRedirect = window.location.pathname !== '/';
    if (shouldRedirect) {
      if (
        zipCodeCookie &&
        zipCodeCookie.loginType === 'CLUB' &&
        zipCodeCookie.loginURL
      ) {
        shouldStoreRedirect &&
          localStorage.setItem('mypolicyRedirectTo', window.location.pathname);

        window.location.replace(zipCodeCookie.loginURL!);
      } else if (zipCodeCookie && zipCodeCookie.loginType === 'DA') {
        shouldStoreRedirect &&
          localStorage.setItem('mypolicyRedirectTo', window.location.pathname);
        window.location.replace('/login');
      } else {
        const zipCodeCheckUrl = shouldStoreRedirect
          ? `/policy-zip?redirectTo=${window.location.pathname}`
          : '/policy-zip';
        window.location.replace(zipCodeCheckUrl);
      }
    }
  }, [error]);
};

export default useAuthCheck;
